import axios from 'axios'

// banner
export function getBanner (datas) {
  const url = '/userCommon/getIndexBanner'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 推荐课程
export function getRecommend (datas) {
  const url = '/userCommon/getRecommendedCourse'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 最新课程
export function getNewGrade (datas) {
  const url = '/userCommon/getLatestCourse'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取过往课程
export function getPastCourses (datas) {
  const url = '/userCommon/getPastCourses'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 用户修改个人资料
export function userFillInformation (datas) {
  const url = '/userCommon/userFillInformation'
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 用户完善年级信息
export function userCompleteGrade (datas) {
  const url = '/userCommon/userCompleteGrade'
  return new Promise((resolve, reject) => {
    axios.put(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 赠送课程列表 1.4
export function getGivingCourseList (datas) {
  const url = '/courseReward/getGivingCourseList'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 登录赠送课程列表 1.4
export function selectCourseList (datas) {
  const url = '/courseReward/selectCourseList'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 领取赠课 1.4
export function receiveCourse (datas) {
  const url = '/courseReward/receiveCourse'
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取头条号列表
export function getForumHomePostPage (datas) {
  const url = '/forumHome/getForumHomePostPage'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 套餐过期或者注册送会员未读消息
export function memberPackageSiteMsgAlarm (datas) {
  const url = '/memberPackage/memberPackageSiteMsgAlarm'
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 会员专区课程列表
export function getMemberPackageCourseList (datas) {
  const url = '/courseDetail/getMemberPackageCourseList'
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 根据开关类型获取审核开关
export function auditButtonManageByType (datas) {
  const url = '/auditButtonManage/auditButtonManageByType'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/index/index.js